import * as yup from 'yup'
import { IS_REQUIRED, MIN_CHARACTERS } from '../../model/constants/validationMessages'

export const FlexiGroupEditSchema = yup.object().shape({
  name: yup.string().min(2, MIN_CHARACTERS).required(IS_REQUIRED),
})
